import { useCallback } from 'react'
import { popupToast } from '@components/Notifications/popupToast'
import { StandardToast } from '@components/Notifications/StandardToast'
import { useMyAbstractAccountAddress } from 'hooks/useAbstractAccountAddress'
import { env } from 'utils/environment'

export function useUsdcTestnetFaucet() {
    const { data: myAbstractAccount } = useMyAbstractAccountAddress()

    return useCallback(() => {
        fetch(`${env.VITE_AA_PAYMASTER_PROXY_URL}/api/onramp/testnet-faucet`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${env.VITE_AUTH_WORKER_HEADER_SECRET}`,
            },
            body: JSON.stringify({
                walletAddress: myAbstractAccount,
            }),
        })
            .then((response) => {
                if (response.ok) {
                    popupToast(({ toast }) => (
                        <StandardToast.Success message="USDC faucet successful" toast={toast} />
                    ))
                } else {
                    popupToast(({ toast }) => (
                        <StandardToast.Error message="USDC faucet failed" toast={toast} />
                    ))
                }
            })
            .catch((error) => {
                console.error('error fetching testnet faucet', error)
                popupToast(({ toast }) => (
                    <StandardToast.Error message="USDC faucet failed" toast={toast} />
                ))
            })
    }, [myAbstractAccount])
}
